import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M9 11a5 5 0 1 0 3.95 7.95","key":"svg-1"}],["path",{"d":"M19 20l-4 -5h-4l3 -5l-4 -3l-4 1","key":"svg-2"}]]

const IconDisabled2 = createReactComponent('outline', 'disabled-2', 'Disabled2', __iconNode);

export default IconDisabled2;